var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonMenuMaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 21,
    height: 18,
    transform: "translate(0 0.307)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button_menu_maxi",
    transform: "translate(-31 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3787",
    "data-name": "Groupe 3787",
    transform: "translate(31 47.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3786",
    "data-name": "Groupe 3786",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13581",
    "data-name": "Trac\\xE9 13581",
    d: "M1.223,0A1.154,1.154,0,0,0,0,1.085a1.3,1.3,0,0,0,0,.138V17.089a1.154,1.154,0,0,0,1.083,1.22,1.3,1.3,0,0,0,.138,0,1.154,1.154,0,0,0,1.22-1.083,1.3,1.3,0,0,0,0-.138V1.223A1.154,1.154,0,0,0,1.361,0a1.3,1.3,0,0,0-.138,0",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13582",
    "data-name": "Trac\\xE9 13582",
    d: "M19.746,9.39h0c0-.122,0-.244.122-.244V8.414l-.122-.122a.122.122,0,0,0-.122-.122L12.3,1.457a1.187,1.187,0,0,0-1.676.084l-.033.038a1.187,1.187,0,0,0,.084,1.676l.038.033,5,4.638H5.222a1.22,1.22,0,1,0,0,2.441H15.474L10.47,15a1.164,1.164,0,0,0,.732,2.075,1.109,1.109,0,0,0,.854-.366L19.38,10a.122.122,0,0,1,.122-.122c.244-.366.244-.488.244-.488",
    transform: "translate(0.882 0.253)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMenuMaxi);
export default __webpack_public_path__ + "static/media/button_menu_maxi.a47c2b0b6842425455b79e5ed02103ff.svg";
export { ForwardRef as ReactComponent };